export default __webpack_public_path__ + "static/media/team3.ec458d05.jpg";